export default __webpack_public_path__ + "static/media/12.0ca62c89.png";